/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { CopyJobWizardStore } from './copy-job-wizard-store';

export const CopyJobWizardStoreContext = createContext<CopyJobWizardStore>({} as CopyJobWizardStore);
